export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'
export const APPEND_BREADCRUMBS = 'APPEND_BREADCRUMBS'
